// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J12p","placeholdersHeader":"styles_placeholdersHeader__2pEgX","editorStyle":"styles_editorStyle__1hktF","placeholdersBox":"styles_placeholdersBox__2NTKi"};